import styled from 'styled-components';

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  background-image: url("../../../assets/backgroundmap.svg");
  background-repeat: no-repeat;
  background-position: center;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 8.6875rem;
`

export const TextContainer = styled.div`
  display: flex;
  width: 24.875rem;
  flex-direction: column;
  margin-right: 8.6875rem;
  p {
    margin-top: 2rem;
    color: var(--grey-100);
  }
  img {
    position: relative;
    width: 14.5rem;
    height: 2.3rem;
    justify-content: center;
    align-items: center;
    margin-bottom: 5rem;
  }
`

export const ForgetPasswordForm = styled.form`
  width: 24.125rem;
  height: 33rem;
  background: var(--black-200);
  border-radius: 4px;
  padding-left: 2rem;
  padding-right: 2rem;

  input {
    margin: 1rem 0 1rem 0 !important;
  }

  a {
    display: flex;
    flex-direction: row;
    margin-top: 2rem;
    align-items: center;
    margin-bottom: 3.6875rem;
    text-decoration: none;
  p {
      color: var(--grey-100);
      width: 210px;
      margin-bottom: 0rem;
      cursor: pointer;
  }
  img {
      margin: 0;
      margin-right: 1rem;
      width: 1.5rem;
      height: 1.5rem;
   }
  }

  p {
    color: var(--grey-100);
    width: 310px;
    margin-bottom: 0rem;
  }
  
  div div:last-of-type {
    margin-bottom: 1.5rem;
  }
  
  h2 {
    margin-bottom: 1rem;
  }

  p {
    color: var(--grey-100);
    margin-bottom: 2.5rem;
    font-size: 0.875rem;
  }
`

export const BackButton = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 2rem;
    align-items: center;
    margin-bottom: 3.6875rem;
    text-decoration: none;
  p {
      color: var(--grey-100);
      width: 210px;
      margin-bottom: 0rem;
      cursor: pointer;
  }
  img {
      margin: 0;
      margin-right: 1rem;
      width: 1.5rem;
      height: 1.5rem;
   }
`

export const FormContent = styled.div`
  padding: 1rem;
`